import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[pimFocusInvalid]',
    standalone: false
})
export class FocusInvalidDirective {
	private selectors: string[] = [
		'.invalid-form-element',
		'pim-input-input.ng-invalid input',
		'pim-input-textarea.ng-invalid textarea',
		'pim-input-select.ng-invalid select',
		'pim-ordered-multiselect.ng-invalid mat-select'
	];

	constructor(private el: ElementRef) {
	}

	@HostListener('submit')
	onFormSubmit(): void {
		// Needs to get the underlying form-element - ng-invalid is set on our form-wrapper-components
		// .invalid-form-element is a custom selector for everything without a form-input and needs to be set manually in the error-case
		setTimeout(() => {
			const invalidControl = this.el.nativeElement.querySelector(this.selectors.join(', '));
			if (invalidControl) {
				invalidControl.focus();
				invalidControl.scrollIntoView({behavior: 'smooth', block: 'center'});
			}
		});
	}

}
